// One source for the visible cosmetic-page questions and their FAQPage schema.

export const cosmeticTrinityFAQs = [
  {
    "question": "Where is your cosmetic dentist office in Trinity?",
    "answer": "Trinity Dental Arts is at 11105 Trinity Blvd, Trinity, FL 34655. Dr. Xhoana Gjelaj provides individual cosmetic treatment planning at this office. Call (727) 228-6846 to discuss your visit."
  },
  {
    "question": "What happens at a cosmetic consultation?",
    "answer": "We discuss what you would like to change, examine your teeth, gums and bite, and explain suitable options. Your written plan sets out recommended stages and fees. The Signature Consultation is $300 prepaid, credited in full toward treatment begun within 30 days; our team confirms availability and arranges prepayment."
  },
  {
    "question": "Can I preview a proposed smile design?",
    "answer": "Digital smile design can help you discuss tooth shape, length and shade. A preview or online smile visualizer is a planning illustration, not a diagnosis or a guarantee of the final result. Your examination determines what changes are appropriate."
  },
  {
    "question": "How much do veneers cost at the Trinity office?",
    "answer": "This page lists porcelain veneers at $1,200–$1,800 per tooth. The number of teeth, preparation and overall treatment plan affect the total. An examination and written estimate establish the fee for your individual care."
  },
  {
    "question": "Why discuss the in-house lab?",
    "answer": "The in-house lab supports communication about restoration design, shade and adjustments. Ask how your case will be fabricated and how many visits may be needed. Laboratory access does not guarantee a particular turnaround or treatment result."
  },
  {
    "question": "How should I compare a cosmetic dentist’s credentials?",
    "answer": "Check the dentist’s license and ask about training relevant to your proposed treatment. Dr. Gjelaj holds MAGD mastership, DABOI/ID diplomate status, DICOI diplomate status and FAAID fellowship. These are different professional credentials; they should not all be described as board certifications."
  }
];

export const cosmeticTampaFAQs = [
  {
    "question": "Do you have a cosmetic dental office in Tampa?",
    "answer": "Our office is at 11105 Trinity Blvd in Trinity, Florida. We welcome Tampa patients at that location. This page describes care for Tampa residents; it does not identify a separate Tampa office."
  },
  {
    "question": "What should I plan before traveling from Tampa?",
    "answer": "Contact our team about appointment availability, the purpose of your first visit and the visits your proposed care may require. Travel time depends on your starting point and traffic, so check current directions to the Trinity office."
  },
  {
    "question": "What does the first cosmetic consultation cost?",
    "answer": "The Signature Consultation is $300 prepaid and is credited in full toward treatment begun within 30 days. Request your preferred time; our team confirms availability and arranges prepayment."
  },
  {
    "question": "How much are veneers and whitening for Tampa patients?",
    "answer": "This page lists porcelain veneers from $1,200 per tooth and professional whitening from $399. A smile makeover has custom pricing. The final scope, treatment stages and fees are explained in your written plan after an individual assessment."
  },
  {
    "question": "Can cosmetic appointments be combined into one trip?",
    "answer": "The number and spacing of visits depend on examination findings, the procedure and any preparation, laboratory or healing stages. Ask the team about scheduling before making travel plans. A fixed number of trips or completion date cannot be promised before assessment."
  },
  {
    "question": "Can whitening change crowns or veneers?",
    "answer": "Whitening changes natural tooth color; it does not whiten crowns, veneers or tooth-colored fillings. Your dentist can discuss how existing restorations affect shade planning. Tooth sensitivity or gum irritation can occur, and the degree of whitening varies."
  }
];

export const veneersTrinityFAQs = [
  {
    "question": "How much do porcelain veneers cost in Trinity, FL?",
    "answer": "This page lists porcelain veneers at $1,200–$1,800 per tooth. The number of teeth, preparation and any related care affect the total. Your clinical assessment is followed by a written plan and individual fees."
  },
  {
    "question": "Is porcelain veneer treatment reversible?",
    "answer": "Porcelain veneers usually require enamel removal, and that change cannot be reversed. Discuss how much preparation is proposed, possible sensitivity, future repair or replacement and alternatives before deciding."
  },
  {
    "question": "Are veneers suitable for every smile concern?",
    "answer": "No. The condition of your teeth and gums, remaining enamel, bite and grinding habits all matter. Whitening, bonding or orthodontic care may address some concerns with a different approach. Decay and gum disease need attention before elective veneer treatment."
  },
  {
    "question": "What stages are involved in veneer treatment?",
    "answer": "Planning may include an examination, photographs or scans and a discussion of shape and shade. If you proceed, treatment can include preparation, temporary restorations when needed, laboratory fabrication and final fit and bite checks. Your clinician explains the visits and timing for your case."
  },
  {
    "question": "How long will my veneers last?",
    "answer": "There is no guaranteed lifespan for an individual veneer. Veneers may chip, loosen, wear or need repair or replacement. Daily cleaning, dental reviews, bite assessment and any recommended protection for grinding are part of ongoing care."
  },
  {
    "question": "Can I see a design before deciding?",
    "answer": "A digital preview can support discussion of the proposed appearance. It is an illustration; your oral health, tooth structure and bite determine what is feasible. Ask how the proposed design will be evaluated before final placement."
  }
];

export const veneersPalmHarborFAQs = [
  {
    "question": "Where do Palm Harbor patients attend veneer appointments?",
    "answer": "Appointments take place at Trinity Dental Arts, 11105 Trinity Blvd, Trinity, FL 34655. We serve Palm Harbor and East Lake patients from this Trinity office. Check current directions and allow for traffic when planning your visit."
  },
  {
    "question": "What veneer fees are listed for Palm Harbor patients?",
    "answer": "This page lists porcelain veneers at $1,200–$2,000 per tooth. That is not a complete smile-makeover quote. The examination, number of teeth and any related care determine the written treatment plan and total fees."
  },
  {
    "question": "How many trips will veneer treatment require?",
    "answer": "Your plan explains consultation, any preparation and temporary-restoration stages, laboratory work and placement checks. The number and spacing of appointments vary. Discuss scheduling with the team before committing to travel dates."
  },
  {
    "question": "Can veneers replace orthodontic treatment?",
    "answer": "Veneers change the visible surface of teeth; they do not move roots or correct every bite problem. Some gaps or tooth-shape concerns may be suitable for veneers, while tooth position or bite issues may call for orthodontic assessment. Your dentist will compare options."
  },
  {
    "question": "What should I know about preparation and maintenance?",
    "answer": "Veneers generally require enamel removal, which is irreversible. They may need future repair or replacement. Teeth beneath and around them still need cleaning and dental reviews; discuss grinding, sensitivity and bite concerns before treatment."
  },
  {
    "question": "How can I discuss a natural-looking result?",
    "answer": "Bring your preferences about shape, shade and how much you want to change. Photographs, scans and a proposed design can help the discussion. Individual anatomy and oral health affect the options, and a preview does not guarantee the final appearance."
  }
];

export const cosmeticServiceFAQs = [
  {
    "question": "Which cosmetic dental options can I compare?",
    "answer": "Depending on your examination and goals, a plan may include whitening, composite bonding, porcelain veneers, gum contouring or clear aligners. These treatments change different things, so compare what each can address, its limitations and any ongoing care."
  },
  {
    "question": "How much does cosmetic dentistry cost?",
    "answer": "The published service cards on this page show the current listed starting fees or ranges for individual procedures. A smile makeover has custom pricing. Your total depends on the procedures, number of teeth and related care; an individual assessment is followed by written fees."
  },
  {
    "question": "Are veneers the same as bonding?",
    "answer": "Porcelain veneers are laboratory-made coverings bonded to the front of teeth and usually require irreversible enamel preparation. Bonding uses tooth-colored resin shaped on the tooth. The suitable option depends on the tooth, the change requested, maintenance and repair considerations."
  },
  {
    "question": "What are the limits and side effects of whitening?",
    "answer": "Whitening can lighten natural teeth, but it does not change the color of crowns, veneers or tooth-colored fillings. Response varies with the cause of discoloration. Temporary sensitivity and gum irritation can occur; discuss suitability and follow product and dentist instructions."
  },
  {
    "question": "Can a digital preview guarantee my new smile?",
    "answer": "No. Digital smile design is a communication and planning tool. It helps you discuss shape, shade and proportions, while your examination, tooth structure, gum health and bite determine the appropriate treatment and its limits."
  },
  {
    "question": "Does insurance cover cosmetic dentistry here?",
    "answer": "Purely cosmetic care is often excluded from dental benefits. Trinity Dental Arts is out of network, does not accept assignment of benefits and does not run benefit searches or submit pre-authorizations. We can file an after-treatment claim for possible reimbursement directly to you; your carrier determines coverage."
  },
  {
    "question": "How do I begin with a cosmetic dentist in Trinity?",
    "answer": "Request a Signature Consultation at our Trinity office or call (727) 228-6846. The consultation is $300 prepaid, credited in full toward treatment begun within 30 days. Our team confirms appointment availability and arranges prepayment; a request alone does not book an appointment."
  }
];

export const cosmeticGuideFAQs = [
  {
    "question": "How should I compare veneers, bonding and whitening?",
    "answer": "Start with the change you want and the health of the tooth. Whitening changes natural tooth color, bonding adds tooth-colored resin, and veneers cover the front surface. Compare preparation, limitations, maintenance and total treatment scope with your dentist."
  },
  {
    "question": "Are porcelain veneers permanent?",
    "answer": "The enamel preparation is irreversible, but the restoration is not guaranteed to last indefinitely. A veneer can chip, crack, loosen or wear and may need repair or replacement. Ask about maintenance and the effect of your bite or grinding habits."
  },
  {
    "question": "Is whitening appropriate for everyone?",
    "answer": "No. A dentist should assess the cause of discoloration and any existing dental problems. Natural teeth and restorations respond differently. Temporary sensitivity or gum irritation can occur, and the result varies by person and method."
  },
  {
    "question": "What should a smile makeover plan explain?",
    "answer": "It should identify the concerns being treated, reasonable alternatives, the sequence of procedures, preparation or healing stages, foreseeable limitations, maintenance and itemized fees. A design illustration supports this discussion but does not guarantee the result."
  },
  {
    "question": "What does a cosmetic dentist’s credential tell me?",
    "answer": "A credential identifies a particular degree, education award or professional designation. Ask what organization issued it and how it relates to your proposed care. A mastership, diplomate designation and fellowship are different categories and should be described accurately."
  },
  {
    "question": "How should I check insurance and financing?",
    "answer": "Check cosmetic exclusions and any out-of-network benefits directly with your carrier. Trinity Dental Arts does not accept assignment of benefits, run benefit searches or submit pre-authorizations; it can file a claim after treatment for possible reimbursement to you. Financing availability is subject to the lender’s current terms and individual approval."
  }
];